import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { FaRegEdit, FaRegTrashAlt, FaFileExport } from "react-icons/fa";
import Swal from "sweetalert2";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ExcelExportColumn } from "@progress/kendo-react-excel-export";
import Spinner from "react-bootstrap/Spinner";
import BASE_API_URL from "../../../../api/api.js";
import apiInstance from "../../../../Utils/api.js";
function CatRegister() {
  const token = localStorage.getItem("token");
  const url = BASE_API_URL;
  const api = apiInstance;

  const scroll = {
    height: "550px",
    overflowY: "scroll",
  };

  const [allLists, setAllLists] = useState([]);
  const [topList, setTopList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [bottomList, setBottomList] = useState([]);
  const [showTop, setShowTop] = useState(false);
  const [showBottom, setShowBottom] = useState(false);
  const [showOrigin, setShowOrigin] = useState(true);
  const [showSearchDate, setShowSearchDate] = useState(false);
  const [to, setTo] = useState("");
  const [from, setFrom] = useState("");
  const [searchByDateList, setSearchByDateList] = useState([]);
  const [topTenList, setTopTenList] = useState([]);
  const [type, setType] = useState("");

  const [showLoad, setShowLoad] = useState(false);
  const timestamp = Date.now(); // Get the current timestamp
  const date = new Date(timestamp); // Create a Date object
  // Extract month, day, and year
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  // Combine them into the desired format
  const formattedDate = `${month}-${day}-${year}`;
  const handleChoose = (event) => {
    if (showSearchDate === true) {
      if (event == "Top") {
        setTopList(searchByDateList.sort((a, b) => b.qty - a.qty));
        setShowTop(true);
        setShowBottom(false);

        setShowOrigin(false);
        setShowSearchDate(true);
      } else {
        setBottomList(searchByDateList.sort((a, b) => a.qty - b.qty));
        setShowTop(false);
        setShowBottom(true);

        setShowOrigin(false);
        setShowSearchDate(true);
      }
    } else {
      if (event == "Top") {
        setTopList(topTenList.sort((a, b) => b.qty - a.qty));
        setShowTop(true);
        setShowBottom(false);

        setShowOrigin(false);
        setShowSearchDate(false);
      } else {
        setBottomList(topTenList.sort((a, b) => a.qty - b.qty));
        setShowTop(false);
        setShowBottom(true);

        setShowOrigin(false);
        setShowSearchDate(false);
      }
    }

    if (event == "All") {
      setShowOrigin(true);
      setShowTop(false);
      setShowBottom(false);

      setShowSearchDate(false);
    }
  };

  const handleFilterDate = async () => {
    // console.log(from, 'from')
    console.log(to, "to");
    setLoading(true);
    const data = {
      start: from,
      end: to,
    };

    if (type) {
      data.purchaseType = type;
    }
    await api
      .get("treatment-selections/top-ten", { params: data })
      .then((res) => {
        setLoading(false);
        setSearchByDateList(res.data.data);
        console.log(res.data.data, "filter date");
        setShowSearchDate(true);
        setShowOrigin(false);
        setShowTop(false);
        setShowBottom(false);
      });
  };
  useEffect(() => {
    const getPackage = async () => {
      try {
        const data = {
          start: formattedDate,
          end: formattedDate,
        };
        const res = await api.get("treatment-selections/top-ten", {
          params: data,
        });

        setTopTenList(res.data.data);

        setAllLists(res.data.data);
        console.log(res.data.data, "ten");
      } catch (err) {}
    };
    getPackage();
  }, []);
  const _export = React.useRef(null);
  const _export1 = React.useRef(null);

  const excelExport = () => {
    if (_export.current !== null) {
      // console.log(_export.current.props.data, 'excel')

      _export.current.props.data.map(function (element, index) {});

      _export.current.save();
    }
  };

  const excelExport1 = () => {
    if (_export1.current !== null) {
      // console.log(_export1.current.props.data, 'excel')

      _export1.current.props.data.map(function (element, index) {});

      _export1.current.save();
    }
  };

  return (
    <>
      {/* @include('sweet::alert') */}

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2 card-header py-3">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item active">Top 10 List</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="row">
                  <div className="col-6">
                    <div className="row">
                      <div className="form-group col-md-3">
                        <label>From</label>
                        <input
                          type="date"
                          name="from"
                          id="from"
                          onChange={(e) => setFrom(e.target.value)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group col-md-3">
                        <label>To</label>
                        <input
                          type="date"
                          name="to"
                          id="to"
                          onChange={(e) => setTo(e.target.value)}
                          className="form-control"
                        />
                      </div>
                      <div className="col-3" style={{ marginTop: "2.6em" }}>
                        <div className="form-group">
                          <select
                            name="currency"
                            id=""
                            className="form-control "
                            // onchange='convert(this.value)'
                            // placeholder='Filter By Branches'
                            onChange={(e) => setType(e.target.value)}
                          >
                            <option hidden>Types</option>

                            <option value="Solid Beauty">Solid Beauty</option>
                            <option value="Normal">Normal</option>
                          </select>
                        </div>
                      </div>
                      <div className="form-group col-md-2">
                        {loading === false ? (
                          <button
                            className="btn btn btn-primary"
                            style={{ marginTop: "35px" }}
                            onClick={() => handleFilterDate()}
                          >
                            Filter
                          </button>
                        ) : (
                          <button
                            className="btn btn-sm btn-primary form-control"
                            style={{ marginTop: "33px" }}
                            disabled
                          >
                            <Spinner
                              as="span"
                              animation="grow"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                            Loading...
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="offset-2 col-4">
                    <div className="row">
                      {showOrigin && (
                        <div
                          className="col-md-3"
                          style={{ marginTop: "2.8em" }}
                        >
                          <button
                            type="button"
                            className="btn btn-sm btn-success"
                            onClick={excelExport1}
                          >
                            <FaFileExport />
                            &nbsp; Export
                          </button>
                          &nbsp;
                        </div>
                      )}
                      {showTop && (
                        <div
                          className="col-md-3"
                          style={{ marginTop: "2.8em" }}
                        >
                          <button
                            type="button"
                            className="btn btn-sm btn-success"
                            onClick={excelExport}
                          >
                            <FaFileExport />
                            &nbsp; Export
                          </button>
                          &nbsp;
                        </div>
                      )}

                      <div className="col-md-6" style={{ marginTop: "2.6em" }}>
                        <div className="form-group">
                          <select
                            name="currency"
                            id=""
                            className="form-control "
                            // onchange='convert(this.value)'
                            // placeholder='Filter By Branches'
                            onChange={(e) => handleChoose(e.target.value)}
                          >
                            <option hidden>Filter By Types</option>
                            <option value="All">All</option>

                            <option value="Top">Top 10</option>
                            <option value="Bottom">Bottom</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <ExcelExport data={searchByDateList} ref={_export}>
                  <ExcelExportColumn
                    field=""
                    title="No"
                    locked={true}
                    width={30}
                  />
                  <ExcelExportColumn
                    field="treatment"
                    title="Treatment"
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    width={200}
                  />
                  <ExcelExportColumn
                    field="treatmentUnit"
                    title="Treatment Unit Name"
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    width={400}
                  />

                  <ExcelExportColumn
                    field="qty"
                    title="Qty"
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    width={250}
                  />

                  <ExcelExportColumn
                    field="sellingPrice"
                    title="Selling Price"
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    width={250}
                  />
                  <ExcelExportColumn
                    field="purchaseType"
                    title="Type"
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    width={250}
                  />
                </ExcelExport>
                <ExcelExport data={allLists} ref={_export1}>
                  <ExcelExportColumn
                    field=""
                    title="No"
                    locked={true}
                    width={30}
                  />
                  <ExcelExportColumn
                    field="relatedTreatment.treatmentName.name"
                    title="Treatment"
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    width={200}
                  />
                  <ExcelExportColumn
                    field="relatedTreatment.name"
                    title="Treatment Unit Name"
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    width={400}
                  />

                  <ExcelExportColumn
                    field="1"
                    title="Qty"
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    width={250}
                  />

                  <ExcelExportColumn
                    field="relatedTreatment.sellingPrice"
                    title="Selling Price"
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    width={250}
                  />
                  <ExcelExportColumn
                    field="purchaseType"
                    title="Type"
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    width={250}
                  />
                </ExcelExport>

                <div class="row">
                  <div class="col-md-12 py-3 card">
                    <div class="card-header">
                      <div class="row" id="trial_balance"></div>
                    </div>
                    <div
                      class="table-responsive text-black"
                      id="slimtest2"
                      style={scroll}
                    >
                      <table class="table table-hover px-3" id="filter_date">
                        <thead class="bg-info text-white sticky-top">
                          <tr>
                            <th>No.</th>

                            <th>Treatment</th>

                            <th>Treatment Unit</th>
                            <th>Qty</th>
                            <th>Selling Price</th>
                            <th>Type</th>
                          </tr>
                        </thead>

                        {showSearchDate &&
                          searchByDateList.map((pack, i) => (
                            <tbody className="">
                              <tr>
                                <td>{++i}</td>

                                <td>{pack?.treatment}</td>
                                <td>{pack?.treatmentUnit}</td>

                                <td>{pack?.qty}</td>
                                <td>{pack?.sellingPrice}</td>
                                <td>{pack ? pack.purchaseType : ""}</td>
                              </tr>
                            </tbody>
                          ))}
                        {showOrigin &&
                          allLists.map((pack, i) => (
                            <tbody className="">
                              <tr>
                                <td>{++i}</td>

                                <td>{pack?.treatment}</td>
                                <td>{pack?.treatmentUnit}</td>

                                <td>{pack?.qty}</td>
                                <td>{pack?.sellingPrice}</td>
                                <td>{pack ? pack.purchaseType : ""}</td>
                              </tr>
                            </tbody>
                          ))}
                        {showTop &&
                          topList.map((pack, i) => (
                            <tbody className="">
                              <tr>
                                <td>{++i}</td>

                                <td>{pack.treatment ? pack.treatment : ""}</td>
                                <td>
                                  {pack.treatmentUnit ? pack.treatmentUnit : ""}
                                </td>

                                <td>{pack.qty}</td>
                                <td>{pack?.sellingPrice}</td>
                                <td>{pack?.purchaseType}</td>
                              </tr>
                            </tbody>
                          ))}
                        {showBottom &&
                          bottomList.map((pack, i) => (
                            <tbody className="">
                              <tr>
                                <td>{++i}</td>

                                <td>{pack.treatment ? pack.treatment : ""}</td>
                                <td>
                                  {pack.treatmentUnit ? pack.treatmentUnit : ""}
                                </td>

                                <td>{pack.qty}</td>
                                <td>{pack?.sellingPrice}</td>
                                <td>{pack?.purchaseType}</td>
                              </tr>
                            </tbody>
                          ))}
                      </table>
                    </div>
                  </div>
                  {/* <div className="col-md-3">
                    <div className="card px-3 py-3">
                      <h5 className="card-header mb-4 text-secondary">
                        Create Reagent
                      </h5>

                      <div class="form-group">
                        <label for="code" className="text-secondary">
                          Code
                        </label>
                        <input
                          type="text"
                          id="code"
                          class="form-control border-info"
                          name="code"
                          //   ref={(el) => (this.name = el)}
                          onChange={(e) => setCode(e.target.value)}
                        />
                      </div>
                      <div class="form-group">
                        <label for="name" className="text-secondary">
                          Name
                        </label>
                        <input
                          type="text"
                          class="form-control border-info"
                          name="name"
                          id="name"
                          //   ref={(el) => (this.name = el)}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </div>
                      <div class="form-group">
                        <label for="name" className="text-secondary">
                          Description
                        </label>
                        <textarea
                          className="form-control"
                          id="desc"
                          //   ref={(el) => (this.description = el)}
                          onChange={(e) =>
                            setDescription(e.target.value)
                          }></textarea>
                      </div>
                      <div class="form-group">
                        <label for="name" className="text-secondary">
                          Flag
                        </label>
                        <select
                          class="custom-select border-info"
                          name="account_type_id"
                          id="flag"
                          onChange={(e) => setFlag(e.target.value)}>
                          <option></option>
                          <option value="Service">Service</option>
                          <option value="Reagent">Reagent</option>
                        </select>
                      </div>
                      <button
                        className="btn btn-primary form-control text-center fw-5"
                        type="submit"
                        onClick={CategoryCreate}>
                        Save
                      </button>
                    </div>
                  </div> */}
                </div>
              </div>

              {/* <ExpenseDialog
                open={open}
                close={() => setOpen(false)}
                expenseLists={expenseLists}
                setExpenseLists={setExpenseLists}
              /> */}
            </div>
            {/*<!-- /.container-fluid --> */}
          </section>
        </div>

    </>
  );
}
export default CatRegister;
